import {
	Page,
	Text,
	Document,
	StyleSheet,
	View,
	Image,
} from "@react-pdf/renderer";
import logoFermat from "../../assets/fermat_logo_3.png";

const styles = StyleSheet.create({
	body: {
		paddingTop: 10,
		paddingBottom: 50,
		paddingHorizontal: 30,
		fontSize: 10,
	},
	footerFixed: {
		position: "absolute",
		bottom: 0,
		margin: 12,
		left: 12,
		width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		color: "#6c757d",
		fontSize: 8,
	},
});

export default function PDFFolhaRostoCTE({ cte, carga, index, totalCTEs }) {
	return (
		<Document>
			<Page style={styles.body}>
				{/* Folha de Rosto do CTE */}
				<View style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
					padding: 40,
				}}>
					{/* Logo */}
					<View style={{ marginBottom: 40, width: "60%" }}>
						<Image src={logoFermat} />
					</View>

					{/* Título */}
					<Text style={{
						fontSize: 24,
						fontWeight: "bold",
						color: "#212529",
						marginBottom: 10,
						textAlign: "center",
					}}>
						📄 CONHECIMENTO DE TRANSPORTE ELETRÔNICO
					</Text>
					<Text style={{
						fontSize: 18,
						color: "#495057",
						marginBottom: 20,
						textAlign: "center",
					}}>
						CTE Nº {index + 1}
					</Text>

					{/* Informações do CTE */}
					<View style={{
						backgroundColor: "#e7f1ff",
						padding: 20,
						borderRadius: 8,
						marginTop: 20,
						width: "80%",
					}}>
						<View style={{ marginBottom: 12 }}>
							<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
								Descrição
							</Text>
							<Text style={{ fontSize: 14, fontWeight: "bold", color: "#212529" }}>
								{cte.descricao || "N/A"}
							</Text>
						</View>
						<View style={{ marginBottom: 12 }}>
							<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
								Nome do Arquivo
							</Text>
							<Text style={{ fontSize: 12, color: "#212529" }}>
								{cte.descricao || "N/A"}
							</Text>
						</View>
						<View>
							<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
								Data de Upload
							</Text>
							<Text style={{ fontSize: 12, color: "#212529" }}>
								{cte.createdAt ? new Date(cte.createdAt).toLocaleString("pt-BR") : "N/A"}
							</Text>
						</View>
					</View>

					{/* Rodapé */}
					<View style={{
						position: "absolute",
						bottom: 30,
						left: 0,
						right: 0,
						textAlign: "center",
					}}>
						<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 5 }}>
							Fermat Indústria e Comércio e Perfis LTDA
						</Text>
						<Text style={{ fontSize: 8, color: "#adb5bd" }}>
							Sistema B-LOG • Documento {index + 1} de {totalCTEs}
						</Text>
					</View>
				</View>

				{/* Footer */}
				<View style={styles.footerFixed} fixed>
					<Text style={{ fontSize: 8 }}>
						CTE {index + 1} de {totalCTEs}
					</Text>
				</View>
			</Page>
		</Document>
	);
}
